var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-tags",style:(_vm.tagStyles),on:{"click":function($event){$event.preventDefault();return _vm.$emit('tag-click', _vm.tag)}}},[_vm._v(" "+_vm._s(_vm.tagLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }